<template>
    <div
        :class="['button-checkbox', modify, {'button-checkbox_theme_toggle': toggle}]"
        @click="$emit('click')">
        <input
            type="checkbox"
            :id="name"
            :name="name"
            :checked="checked"
            :disabled="disabled"
            class="button-checkbox__input"
        >
        <label class="button-checkbox__label" :for="name">
            <span class="button-checkbox__text">{{ value }}</span>
            <span v-if="time" class="button-checkbox__time">{{ time }}</span>
            <span v-if="toggle" class="button-checkbox__toggle-icon"></span>
        </label>
    </div>
</template>

<script>
export default {
    props: ['modify', 'name', 'value', 'time', 'checked', 'disabled', 'toggle']
};
</script>

